import { render } from "./BasicLabel.vue?vue&type=template&id=ed3de314&scoped=true"
import script from "./BasicLabel.vue?vue&type=script&lang=js"
export * from "./BasicLabel.vue?vue&type=script&lang=js"

import "./BasicLabel.vue?vue&type=style&index=0&id=ed3de314&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ed3de314"

export default script